export default __webpack_public_path__ + "static/constat_en-bf1088a647e1dc83d79a7f046de05ac9.mp4";